import {
    GA4EventName,
    GA4FeatureCategory,
    trackAnalyticsEvent,
    trackProductTileServiceInteraction,
} from '@jsmdg/tracking';

const trackServicesToggleClicked = (showServices: boolean): void => {
    if (!showServices) {
        setTimeout(() => {
            trackProductTileServiceInteraction('ProductTile', 'Expand', 'Services');
        }, 0);
    }
};

const trackServicesCloseClicked = (): void => {
    setTimeout(() => {
        trackProductTileServiceInteraction('ProductTile', 'Close', 'Services');
    }, 0);
};

async function trackProductTileView(title: string, position: number): Promise<void> {
    await window.yieldToMainThread();
    trackAnalyticsEvent({
        eventData: {
            featureCategory: GA4FeatureCategory.ProductdetailBoxList,
            eventName: GA4EventName.ViewProductSelectorBlock,
            productTitle: title,
            position,
        },
    });
}

export { trackProductTileView, trackServicesCloseClicked, trackServicesToggleClicked };
